import { render, staticRenderFns } from "./HoursOfOperationBreaks.vue?vue&type=template&id=52a8f4fc"
import script from "./HoursOfOperationBreaks.vue?vue&type=script&lang=js"
export * from "./HoursOfOperationBreaks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports